import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {Master} from '../../../../admin/models/master.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatSort} from '@angular/material/sort';
import {PageEvent} from '@angular/material/paginator';
import {MatCheckboxChange} from '@angular/material/checkbox';

@Component({
  selector: 'app-kf-configuration-edit-table',
  templateUrl: './kf-configuration-edit-table.component.html',
  styleUrls: ['./kf-configuration-edit-table.component.scss']
})
export class KfConfigurationEditTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['code', 'description', 'comment', 'scope'];

  @Input()
  list!: Master[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;
  @Input()
  selectedItems?: number[];
  @Input()
  type!: string;

  @Output()
  loadItems: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  addSelectedItem: EventEmitter<number> = new EventEmitter<number>();
  @Output()
  removeSelectedItem: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor() { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadItems.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadItems.emit({page: event.pageIndex, size: event.pageSize});
  }

  isItemChecked(item: Master): boolean {
    if (this.selectedItems) {
      return this.selectedItems.includes(item.id);
    }
    return false;
  }

  onCheckboxChange(event: MatCheckboxChange): void {
    const id: number = + event.source?.id.replace(`${this.type}-`, '') || 0;
    if (event.checked) {
      this.addSelectedItem.emit(id);
    } else {
      this.removeSelectedItem.emit(id);
    }
  }
}
